import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Context } from '@front10/helpers/dist/Context';
import Button from '../../../elements/Button';

class Dot extends PureComponent {
  componentDidUpdate(prevProps) {
    const { isDotVisible } = this.props;
    if (prevProps.isDotVisible !== isDotVisible) {
      this.hideParentNode();
    }
  }

  hideParentNode = () => {
    const { isDotVisible } = this.props;
    const { parentNode } = this.reference;
    if (!isDotVisible) {
      parentNode.classList.remove('fr-d-inline-block');
      parentNode.classList.add('fr-d-none');
    } else {
      parentNode.classList.remove('fr-d-none');
      parentNode.classList.add('fr-d-inline-block');
    }
  };

  render() {
    const { translate } = this.context;
    const { isDotVisible, pageNumber } = this.props;
    return (
      <Button
        tabIndex={-1}
        focusReferences={(ref) => {
          this.reference = ref;
        }}
        display={isDotVisible ? 'block' : 'none'}
        ariaLabel={`${translate('cmp-carousel-dot', 'Go to slide')} ${pageNumber + 1}`}
        {...this.props}
      />
    );
  }
}

Dot.propTypes = {
  /**
   * Determine if the dot is visible
   */
  isDotVisible: PropTypes.bool,
  /**
   * Value of page
   */
  pageNumber: PropTypes.number
};
Dot.defaultProps = {
  isDotVisible: true,
  pageNumber: null
};
Dot.componentName = 'Dot';
Dot.contextType = Context;

export default Dot;
